/**
 * BlogMessage Data Model (Firestore: blogMessages)
 * One post per document. Link to cohort via cohortId (number).
 * Required: cohortId, messageTitle, messageBody. postedDate defaults to now.
 */
export class BlogMessage {
  constructor(data) {
    this.id = data.id || null;
    this.cohortId = data.cohortId || null;
    this.messageTitle = data.messageTitle || '';
    this.messageBody = data.messageBody || '';
    this.postedDate = data.postedDate || null;
    this.createdBy = data.createdBy || 'Anonymous';
    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }

  /**
   * Convert Firestore document to BlogMessage instance
   */
  static fromFirestore(doc) {
    const data = doc.data();
    return new BlogMessage({
      id: doc.id,
      ...data,
      // Convert Firestore timestamps to Date objects
      postedDate: data.postedDate?.toDate() || null,
      createdAt: data.createdAt?.toDate() || null,
      updatedAt: data.updatedAt?.toDate() || null,
    });
  }

  /**
   * Convert BlogMessage instance to Firestore document data
   * Note: Timestamp conversion is handled in the service layer
   */
  toFirestore() {
    return {
      cohortId: this.cohortId,
      messageTitle: this.messageTitle,
      messageBody: this.messageBody,
      postedDate: this.postedDate,
      createdBy: this.createdBy,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
